/* eslint-disable no-template-curly-in-string */
/* eslint-disable prettier/prettier */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
// import { GoogleMap, Marker } from "react-google-maps";
import React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';

export interface IAddressListModalProps {
    isOpen: any;
    onRequestClose: () => void;
    addressData: any;
    activeModalContent: string;
    setActiveModalContent: (data: string) => void;
    addressPurposes: any;
    selectedAddress: any;
    setSelectedAddress: (data: any) => void;
    setAddressBarDetails: (data: string) => void;
}

/**
 *
 * AddressListModal component.
 * @extends {React.PureComponent<IAddressListModalProps>}
 */

@observer
export class AddressListModal extends React.PureComponent<IAddressListModalProps> {
    constructor(props: IAddressListModalProps) {
        super(props);
    }

    public componentDidMount() {

    }
    public componentDidUpdate(): void {

    }

    public confirmSelectAddress(): void {
        this.props.onRequestClose();
        const element = document.querySelector(`input[type='radio'][name=selected-address]:checked`) as HTMLInputElement;
        if(element){
            this.props.setAddressBarDetails(element.dataset?.street ? element.dataset?.street : 'Select location');
        }
    }
    public render(): JSX.Element {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onRequestClose} modalClassName='address-lsit-modal'>
                <div className='row localy-address'>
                <ModalHeader>
                    <div className='row saved-address-top'>
                        <div className='saved-address'>
                            Saved Address
                        </div>
                        <div className='add-new-address'>
                            <button onClick={() => {this.props.setActiveModalContent('location');}} className='add-new-address-global'>
                                <span>Add New Address</span>
                            </button>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {this.props.addressData.map((item: any) => {
                        const addressType = this.props.addressPurposes.filter(
                            (addressTypeValue: { AddressType: any }) => addressTypeValue.AddressType === item.AddressTypeValue
                        );
                        const addressTypeValue = addressType.length > 0 ? addressType[0].Description : '';
                            return (
                                <>
                                    <div className="global-address">
                                        <input type='radio' value={item?.RecordId} name='selected-address'
                                        checked={this.props.selectedAddress === item.RecordId} onClick={() => {
                                            this.props.setSelectedAddress(item.RecordId);
                                            this.props.setAddressBarDetails(`${addressTypeValue} - ${item.Street}`);
                                        }}
                                         data-street={`${addressTypeValue} - ${item.Street}`}
                                         className="msc-address-select__input"></input>

                                        <div className='address-detail'>
                                            <p className='ms-address-type'>
                                                <span className='ms-address-type-value'>{addressTypeValue}</span>
                                            </p>
                                            <p className='ms-address-details'>
                                                {`${item.Street}`}
                                                {item?.StreetNumber && item?.StreetNumber !== '' && ` , ${item.StreetNumber}`}
                                                {item?.BuildingCompliment && item?.BuildingCompliment !== '' && ` , ${item.BuildingCompliment}`}
                                                {item?.City && item?.City !== '' && ` , ${item.City}`}
                                            </p>
                                            <p className='ms-address-name'>{`${item.Name}, ${item.Phone}`}</p>
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                </ModalBody>
                <ModalFooter>
                    <button onClick={() => {this.confirmSelectAddress();}} className='confirm-address-button deliver-here-button'>
                        <span>Delivery Here</span>
                    </button>

                </ModalFooter>
                </div>
            </Modal>
        );
    }
}